import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import InputFields from "../../utils/UserInput";
import { message, Modal, Select, Typography } from "antd";
import ImageUpload from "../UsersPage/UploadImage";
import { MultiPostRequest } from "../../utils/APICall";
import moment from "moment";
import { useSelector } from "react-redux";
// import ImageUpload from "./UploadImage";

const EditEmpForm = ({ visible, onClose, empData, desigOpt, deptOpt, skillData }) => {
  const { users } = useSelector((state) => state.user || {})
  console.log(empData)
  const [selectSkillID, setSelectSkillID] = useState([]);
  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required("First name is required"),
    // lastName: Yup.string().required("Last name is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    phone: Yup.string().required("Phone is required"),
    // employeeId: Yup.string().required("Employee ID is required"),
  });

  const initialValues = {
    firstName: empData?.FIRSTNAME || "",
    lastName: empData?.LASTNAME || "",
    email: empData?.EMAIL || "",
    // joinDate: empData?.JOININGDATE ? new Date(empData?.JOININGDATE).toISOString().split('T')[0] : "",
    joinDate: empData?.JOININGDATE ? moment(empData?.JOININGDATE).format("DD-MM-YYYY") : "",
    // leavingDate: empData?.EXITDATE ? new Date(empData?.EXITDATE).toISOString().split('T')[0] : "",
    leavingDate: empData?.EXITDATE ? moment(empData?.EXITDATE).format("DD-MM-YYYY") : "",
    department: empData?.DEPT_TITLE || "",
    designation: empData?.DESIG_TITLE || "",
    qualification: empData?.QUALIFICATION || "",
    phone: empData?.PHONE || "",
    major: empData?.MAJOR || "",
    accTitle: empData?.BANKACCOUNTTITLE || "",
    bankBranch: empData?.BANKBRANCH || "",
    bankName: empData?.BANKNAME || "",
    accNo: empData?.ACCOUNTNO || "",
    IBNNo: empData?.IBNNO || "",
    employeeId: empData?.EMPLOYEEID || "",
    emergencyNum: empData?.EMERGENCYCONTACT || "",
  };
  // console.log("initialValues",initialValues)

  const [dataFiles, setDataFiles] = useState([]);
  const [images, setImages] = useState([]);
  useEffect(() => {
  if (empData?.IMAGEURL) {
    setImages([
      {
        name: "existing_image",
        url: empData.IMAGEURL,
      },
    ]);
  } else {
    setImages([]);
  }
}, [empData]);
  const DesigOpt = desigOpt?.map((desig) => ({
    value: String(desig.CODE),
    label: desig.TITLE,
  })) || [];

  const DeptOpt =
    deptOpt?.map((dept) => ({
      value: dept.CODE,
      label: dept.TITLE,
    })) || [];

  const optionQua =
    skillData?.qualification?.map((skill) => ({
      value: skill.ID,
      label: skill.TITLE,
    })) || [];

  const optionSkill =
    skillData?.skills?.map((skill) => ({
      value: skill.ID,
      label: skill.TITLE,
    })) || [];
  // console.log(optionSkill)

  const handleChangeSkills = (value) => {
    setSelectSkillID(value);
  };
  useEffect(() => {
  if (empData?.SKILLS) {
    const ids = empData.SKILLS.split(" | ").map(id => Number(id.trim()));
    setSelectSkillID(ids);
  }
}, [empData]);

  const handleSubmit = async (values, { resetForm, setSubmitting }) => {
    const getFinalValue = (formValue, empValue) => {
      if (formValue === undefined) {
        // User ne input touch hi nahi kiya
        return empValue || "";
      }

      // Agar user ne kuch likha but it's empty string or "null"
      if (formValue === null || formValue === "null" || formValue.trim() === "") {
        return "";
      }

      // Agar user ne purani value change nahi ki
      return formValue === empValue ? empValue : formValue;
    };
    const formData = new FormData();
    formData.append("vId", empData?.ID || 0);
    formData.append("vEmployeeId", empData?.EMPLOYEEID || 0);
    formData.append("firstName", values.firstName ? values.firstName : empData?.FIRSTNAME || null);
    // formData.append("lastName", values.lastName ? values.lastName :  empData?.LASTNAME ||  null );
    formData.append("lastName", getFinalValue(values.lastName, empData?.LASTNAME));
    formData.append("email", values.email ? values.email : empData?.EMAIL || null);
    formData.append("joinDate", values.joinDate ? values.joinDate : empData?.JOININGDATE ? new Date(empData?.JOININGDATE).toISOString().split('T')[0] : "");
    formData.append("leavingDate", values.leavingDate ? values.leavingDate : null || empData?.EXITDATE);
    formData.append("department", isNaN(Number(values.department)) || values.department === "" || values.department === null
      ? empData?.DEPARTMENT_ID ?? 0
      : values.department);
    formData.append("designation", isNaN(values.designation)
      ? empData?.DESIGNATION_ID
      : values.designation === "" || values.designation === null
        ? 0
        : values.designation);
    formData.append("qualification", isNaN(values.qualification) ? empData?.QUALIFICATION : values.qualification);
    formData.append("phone", values.phone ? values.phone : empData?.PHONE);
    formData.append("emergencyNum", values.emergencyNum ? values.emergencyNum : empData?.EMERGENCYCONTACT);
    formData.append("major", getFinalValue(values.major, empData?.MAJOR));
    formData.append("accTitle", getFinalValue(values.accTitle, empData?.BANKACCOUNTTITLE));
    formData.append("bankBranch", getFinalValue(values.bankBranch, empData?.BANKBRANCH));
    formData.append("bankName", getFinalValue(values.bankName, empData?.BANKNAME));
    formData.append("accNo", getFinalValue(values.accNo, empData?.ACCOUNTNO));
    formData.append("IBNNo", getFinalValue(values.IBNNo, empData?.IBNNO));
    formData.append("certificate", values.certificate ? values.certificate : null);
    formData.append("createdby", `${users?.FIRSTNAME} ${users?.LASTNAME}| ${moment(Date.now()).format("DD-MM-YYYY HH:mm")}`);


    if (selectSkillID.length !== 0) {
      formData.append("skills", JSON.stringify(selectSkillID));
    }

    if (dataFiles[0]) {
      formData.append("document", dataFiles[0]); // New file agar user ne upload ki hai
    } else {
      formData.append("vfkImageId", empData?.FKIMAGEID || 0);
      formData.append("document", null); // No change in image
    }
    // console.log("Submitting employee data:", Object.fromEntries(formData));
    const empResponse = await MultiPostRequest("addemp", formData);
    // console.log("addemp response:", empResponse);
    if (empResponse.status) {
      onClose()
      resetForm()
      window.location.reload()
    }
    if (!empResponse.status) {
      message.error(empResponse?.details || "Failed to add employee");
      // onClose()
      // resetForm()
      return;
    }

  };
  return (
    <Modal
      key={empData?.ID}
      title={
        <div className="text-xl text-center font-bold ">Edit Employee</div>
      }
      open={visible}
      onCancel={onClose}
      footer={null}
    >
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({ isSubmitting }) => (
          <Form >
            <span className="flex justify-center items-center py-4 ">
              <ImageUpload setData={setDataFiles} images={images} setImages={setImages} />

            </span>
            <span className="grid  grid-cols-1 gap-2 md:grid-cols-2 ">
              <InputFields
                label="First Name"
                type="text"
                placeholder="Enter your firstName"
                name="firstName"
              />
              <InputFields
                label="Last Name"
                type="text"
                placeholder="Enter lastName"
                name="lastName"
              />

              <InputFields
                label="Email"
                type="email"
                name="email"
                placeholder="Enter Email"
              />
              <InputFields
                label="EmployeeID"
                type="EmployeeID"
                name="employeeId"
                placeholder="Enter EmployeeID"
                disabled={true}
              />
              <InputFields
                label="Joining Date"
                type="date"
                name="joinDate"
                placeholder="Enter Joining Date"
              />
              <InputFields
                label="Leaving Date*"
                type="date"
                name="leavingDate"
                placeholder="Enter Leaving Date"
              />
              <InputFields
                label="Qualification*"
                type="select"
                name="qualification"
                placeholder="Enter Qualification (optional)*"
                options={optionQua}
              />
              <InputFields
                label="Major"
                type="text"
                placeholder="Enter Major"
                name="major"
              />
              <InputFields
                label="Certificate*"
                type="text"
                placeholder="Enter Cetificate (optional)*"
                name="cetificate"
              />
              <InputFields
                label="Phone"
                type="number"
                name="phone"
                placeholder="Enter Phone"
              />
              <InputFields
                label="Emergency Number"
                type="number"
                name="emergencyNum"
                placeholder="Enter Emergency / Secondary Number"
              />
              <InputFields
                label="Department"
                type="select"
                name="department"
                placeholder="Enter Department "
                options={DeptOpt}
              />
              <InputFields
                label="Designation"
                type="select"
                name="designation"
                placeholder="Enter Designation "
                options={DesigOpt}
              />
              <span className="w-full">
                <Typography.Text strong>Select Skills</Typography.Text>
                <Select
                  mode="multiple"
                  style={{ width: "100%" }}
                  placeholder="Add Skills"
                  onChange={handleChangeSkills}
                  value={selectSkillID}    
                  options={optionSkill}
                  optionFilterProp="label"
                />
              </span>
              <InputFields
                label="Account Title"
                type="text"
                name="accTitle"
                placeholder="Enter Account Title"
              />
              <InputFields
                label="Bank Name"
                type="text"
                placeholder="Enter Bank Name"
                name="bankName"
              />
              <InputFields
                label="Bank Branch"
                type="text"
                placeholder="Enter Bank Branch"
                name="bankBranch"
              />
              <InputFields
                label="Account No"
                type="text"
                placeholder="Enter Account No"
                name="accNo"
              />
              <InputFields
                label="IBN No"
                type="text"
                placeholder="Enter IBN No"
                name="IBNNo"
              />

            </span>
            <button
              type="submit"
              disabled={isSubmitting}
              className="mt-6 flex justify-center items-center mx-auto w-full  max-h-10 bg-blue-500 text-white px-4 py-2 rounded"
            >
              {isSubmitting ? "Submitting..." : "Submit"}
            </button>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default EditEmpForm